import Default from "./ReadonlyCertificate";
export * from "./ReadonlyCertificate";

export default Default;
